import { FaFilePdf } from "react-icons/fa";
import { LibraryViewMain } from "../Components/LibraryViewMain";

export const LibraryModule = () => [{
    views: "PRIVATE", path: "/library", component: <LibraryViewMain />,
    roles: null, permissions: null, label: "Biblioteca", icon: <FaFilePdf />,
    displayInHeader: false, displayInFooter: false, displayInSidebar: true,
    isBlockedWhenLogged: false,
}];
